import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, IconButton, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users } from "../../API/Users";
import TileSessions from "./TileSessions";

export default function TileUsers() {
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      width={"100%"}
      justifyContent={"center"}
      gap={2}
    >
      <UserTile
        title={"Partners"}
        type={"PARTNER"}
        onclick={() => {
          // redirecting to account page with filter presetted
          navigate("/accounts?levelFilter=PARTNER");
        }}
      />
      <UserTile
        title={"Internals"}
        type={"INTERNAL"}
        onclick={() => {
          // redirecting to account page with filter presetted
          navigate("/accounts?levelFilter=INTERNAL");
        }}
      />
      <TileSessions />
    </Box>
  );
}

type UserTileProps = { title: string; type: string; onclick: Function };
const UserTile = ({ title, type, onclick }: UserTileProps) => {
  const userAPI = useMemo(() => new Users(), []);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    try {
      userAPI
        .selectUsers({
          filters: [
            {
              dimension: "active",
              segments: [true],
            },
            {
              dimension: "level",
              segments: [type],
            },
          ],
        })
        .then((response) => {
          setTotal(response.data.total);
        });
    } catch (error) {
      throw new Error();
    }
  }, [type, userAPI]);

  return (
    <Box p={1} boxShadow={3} borderRadius={2}>
      <Typography display={"flex"} gap={2} alignItems={"center"}>
        <strong>{total ? total : 0}</strong> {title}
        <IconButton onClick={() => onclick()} color="secondary" size="small">
          <OpenInNewIcon />
        </IconButton>
      </Typography>
    </Box>
  );
};
